<template>
  <div>
    <el-tabs v-model="activeTab" @tab-click="handleClick">
      <el-tab-pane label="eBIRForms" name="eBIRForms">{{msg}}</el-tab-pane>
      <el-tab-pane label="eFPSFiling" name="eFPSFiling">{{msg}}</el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>

  export default {
    name: 'TaxReporting',
    components: {},
    data() {
      return {
        activeTab: 'eBIRForms',
        msg: 'Sorry, this feature now under development will be ready later.',
      }
    },
    methods: {
      loadList() {
        this.activeTab = 'eBIRForms'
        // this.$refs['GLTaxAccounts'].loadList()
      },
      handleClick(tab, event) {
        if (tab.name === 'eBIRForms'){
          // this.$refs['GLVATAccounts'].loadList()
        }
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>